import { render } from "./LockedExpansion.vue?vue&type=template&id=101ed0b2"
import script from "./LockedExpansion.vue?vue&type=script&lang=js"
export * from "./LockedExpansion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__